"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMobileSubMenu = exports.StyledMobileLinkText = exports.StyledMobileContainer = exports.StyledMobileMenuItemLink = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = require("../../../Text");

var _NavMenuItem = require("../NavMenuItem.styled");

var _colors = require("../../../../utils/colors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: 6rem;\n  padding-left: 0.7625rem;\n\n  border-left: 1px solid\n    ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.725rem;\n  font-weight: ", ";\n  color: ", ";\n  font-family: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 1.6rem;\n  li {\n    text-align: ", ";\n    a {\n      span {\n        line-height: 1;\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-image: unset;\n  align-items: flex-start;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledMobileMenuItemLink = (0, _styledComponents.default)(_NavMenuItem.StyledMenuItemLink)(_templateObject(), function (props) {
  return (0, _colors.normaliseColor)(props.theme.Nav.textColor, props.theme);
});
exports.StyledMobileMenuItemLink = StyledMobileMenuItemLink;

var StyledMobileContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.Nav.modal.textAlign;
});

exports.StyledMobileContainer = StyledMobileContainer;
var StyledMobileLinkText = (0, _styledComponents.default)(_Text.Text)(_templateObject3(), function (props) {
  return props.theme.Nav.modal.fontWeight;
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.Nav.textColor, props.theme);
}, function (props) {
  return props.theme.Nav.fontStyle.fontFamily;
});
exports.StyledMobileLinkText = StyledMobileLinkText;

var StyledMobileSubMenu = _styledComponents.default.div(_templateObject4(), function (props) {
  return props.theme.dark ? props.theme.colors.brandThemeDark700 : props.theme.colors.brandThemeLight500;
});

exports.StyledMobileSubMenu = StyledMobileSubMenu;